import React from 'react';

const defaultState = {
  isAuth: false,
  toggleAuth: () => {},
}
const AuthContext = React.createContext(defaultState)

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = React.useState(false);
  
  const toggleAuth = () => {
    setAuth(!auth)
  }
  
  return (
    <AuthContext.Provider
      value={{
        auth,
        toggleAuth
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext;
export { AuthProvider };